import { useCallback, useEffect, useState } from 'react'

const useMultipleSalesInvoicePaymentTerm = ({ form, onChange, lines, company, calculatesDueDate }) => {
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null)

  const problem = useCallback(
    () => lines?.filter(
      (line) => line?.paymentTerm && line?.paymentTerm?.days !== selectedPaymentTerm?.days
    )?.length > 0,
    [lines, selectedPaymentTerm, company?.paymentTerms]
  )

  const companyPaymentTermDays = useCallback(
    () => (company && company?.paymentTerms ? company.paymentTerms?.map(
      (term) => term?.days
    ) : []),
    [company]
  )

  const paymentTermsOfTransactions = useCallback(
    () => lines?.filter(line => line?.paymentTerm && line?.paymentTerm?.days)
      .map(line => ({ id: line?.transactionId, ...line?.paymentTerm })), [lines, companyPaymentTermDays]
  )

  const onPaymentTermChange = useCallback((_, paymentTerm) => {
    if (paymentTerm) {
      let selectedPaymentTerm
      if (paymentTerm && paymentTerm?.includes('company_')) {
        const checkFor = paymentTerm?.replace('company_', '')
        selectedPaymentTerm = company?.paymentTerms?.find(item => parseInt(item.id, 10) === parseInt(checkFor, 10))
        if (!selectedPaymentTerm) {
          selectedPaymentTerm = company?.paymentTerms?.length ? company.paymentTerms[company.paymentTerms.length - 1] : null
        }
      } else {
        const checkFor = paymentTerm?.replace('transaction_', '')
        selectedPaymentTerm = paymentTermsOfTransactions()?.find(item => parseInt(item?.id, 10) === parseInt(checkFor, 10))
      }
      setSelectedPaymentTerm(selectedPaymentTerm)

      calculatesDueDate(selectedPaymentTerm, form?.dispatchDate)
    }
    onChange('paymentTerm', paymentTerm)
  }, [company?.paymentTerms, form?.dispatchDate, selectedPaymentTerm, paymentTermsOfTransactions])

  useEffect(() => {
    if (form?.paymentTerm && typeof form?.paymentTerm === 'string') {
      onPaymentTermChange('paymentTerm', form.paymentTerm)
    }
  }, [form?.paymentTerm, company?.paymentTerms, lines])

  const paymentTerms = useCallback(
    () => {
      const terms = company && company.paymentTerms ? company.paymentTerms.map(item => ({
        value: 'company_' + item?.id,
        label: item?.type?.name + ' / ' + item.days + ' D'
      })) : []
      for (let i = 0; i < paymentTermsOfTransactions().length; i++) {
        terms.push({
          value: 'transaction_' + paymentTermsOfTransactions()[i].id,
          label: paymentTermsOfTransactions()[i]?.type + ' / ' + paymentTermsOfTransactions()[i]?.days + ' D'
        })
      }
      return terms
    },
    [company, paymentTermsOfTransactions, lines]
  )

  return {
    allPaymentTerms: paymentTerms(),
    selectedPaymentTerm,
    onPaymentTermChange,
    setSelectedPaymentTerm,
    paymentTermProblem: problem()
  }
}

export default useMultipleSalesInvoicePaymentTerm
